
programModelReportStates = ($stateProvider, TagUrl) ->
    'ngInject'

    url = new TagUrl()
        .addTagTypes(['program', 'location'])
        .setTagDefault('affiliation', 'all')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'program.name')

    $stateProvider.state 'reports.programModel',
        url: url.buildUrl('/model')
        params: url.params
        templateUrl: 'reports/programModel/base'
        data:
            tagUrl: url
        controller: 'ProgramModelReportController'
        controllerAs: '$ctrl'
        resolve:
            data: resolveProgramModelData
        reloadOnSearch: false
        abstract: true

    $stateProvider.state 'reports.programModel.section',
        url: '/{section}'
        reloadOnSearch: false
        templateUrl: ($stateParams) ->
            name = $stateParams.section.replace('-', '_')
            return "reports/programModel/#{name}"


### @ngInject ###
resolveProgramModelData = (ProgramModelReportService, $stateParams) ->
    return ProgramModelReportService.loadData($stateParams)


class ProgramModelReportService

    ### @ngInject ###
    constructor: (@$http, @ApiUrl) ->

    loadData: (params) ->
        url = @ApiUrl('reports', 'program_model')
        return @$http.get(url, params: params)
            .then((result) -> result.data)


class ProgramModelReportController

    ### @ngInject ###
    constructor: ($scope, $state, $timeout, $stateParams, data, ProgramModelReportService, @FileService, @ApiUrl) ->
        @scope = $scope
        @state = $state
        @timeout = $timeout
        @loading = false
        @service = ProgramModelReportService
        @data = data

        @sort = $stateParams.sort
        @page = $stateParams.page

        @scope.$watch '$ctrl.data.page', @turnPage

    reload: () =>
        @loading = true
        @service.loadData(@state.params).then (result) =>
            @data = result
            @loading = false

    triggerReload: () ->
        clearTimeout(@timeoutId)
        @timeOutId = @timeout @reload, 10

    turnPage: (page) =>
        if page == @page then return
        @page = page
        @state.go('.', {page: page}, {location: 'replace'})
        @triggerReload()

    setSort: (sort) =>
        @state.go('.', {page: 1, sort: @sort}, {location: 'replace'})
        @triggerReload()

    tagChange: (tags) ->
        clearTimeout(@setTagTimepout)
        @setTagTimApiUrlepout = @timeout (() => @setTags(tags)), 10

    downloadFile: ->
        url = @ApiUrl('reports', 'program_model', 'export.xlsx')
        @downloading = true
        @FileService.downloadFile(url, @tags).then =>
            @downloading = false
            return

        return

    setTags: (tags) ->

        if !@tags
            @tags = tags
            return

        if !angular.equals(tags, @tags)
            @tags = tags
            @state.go('.', tags, {location: 'replace'})
            @turnPage(1)
            @triggerReload()
            return

    months: (() -> moment(new Date(2017, i, 1)).format('MMM') for i in [0..11])()

    sections: [
        {id: 'info', label: 'Program Info'}
        {id: 'sponsor', label: "Sponsoring Org"}
        {id: 'enrollment', label: 'Enrollment Info'}
        {id: 'enrollment-dates', label: 'Enrollment Dates'}
        {id: 'education', label: 'Education Practices'}
        {id: 'career-pathways', label: 'Career Pathways'}
        {id: 'design', label: 'Program Design'}
        {id: 'pse-bridging', label: 'PSE Bridging Activities'}
        {id: 'misc', label: 'Miscellaneous'}
    ]


module.controller 'ProgramModelReportController', ProgramModelReportController
module.config programModelReportStates
module.service 'ProgramModelReportService', ProgramModelReportService
